import { Box, MenuItem, Select, TextField } from '@mui/material'
import { createNoticeResponse, updateNoticeResponse } from 'api/services/automation/config'
import DialogWrapper from 'components/DialogWrapper'
import FormDate from 'components/FormFields/FormDate'
import Loader from 'components/Loader'
import LoadingButton from 'components/LoadingButton'
import SafeTextField from 'components/SafeTextField'
import { snack } from 'components/toast'
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'
import { handleError } from 'utils/handleError'
let addFyaNotice = {
  responseType: "FR",
  submittedOn: null,
  remarks: ""
}

interface fyaNotice {
  responseType: string;
  remarks: string;
  submittedOn: any
}

interface CreateNoticeResponseProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  state?: any;
  isEdit?: boolean;
  editItem?: any;
}

const CreateNoticeResponse = ({ open, setOpen, state, isEdit, editItem }: CreateNoticeResponseProps) => {
  const queryClient = useQueryClient()
  const { control, handleSubmit, reset, register } = useForm<fyaNotice>({
    defaultValues: addFyaNotice,
    mode: "onChange"
  })

  const { mutate, isLoading } = useMutation(createNoticeResponse, {
    onSuccess: () => {
      snack.success("Notice Response Added")
      queryClient.invalidateQueries("e-proceeding-notice")
      reset()
      setOpen(false)
    },
    onError: (error) => {
      snack.error(handleError(error))
    }
  })

  const { mutate: mutateEdit, isLoading: isLoadingEdit } = useMutation(updateNoticeResponse, {
    onSuccess: () => {
      snack.success("Notice Response Updated")
      queryClient.invalidateQueries("e-proceeding-notice")
      reset()
      setOpen(false)
    },
    onError: (error) => {
      snack.error(handleError(error))
    }
  })

  const onSubmit = async (item) => {
    item.remarks = item?.remarks?.trim()
    if (!item?.submittedOn) {
      return snack.error("Submitted On is mandatory")
    }
    if (isEdit && editItem) {
      editItem.responseType = item.responseType
      editItem.submittedOn = item.submittedOn
      editItem.remarks = item.remarks
      mutateEdit({
        ...editItem
      })

    } else {
      console.log(item, "item")
      item['noticeId'] = state?.id
      item['clientId'] = state?.client?.id
      mutate({
        ...item
      })
    }
  }

  useEffect(() => {
    if (isEdit) {
      reset({
        responseType: isEdit ? editItem?.responseType : "FR",
        submittedOn: isEdit ? editItem?.submittedOn : null,
        remarks: isEdit ? editItem?.remarks : ""
      })
    }
  }, [isEdit, editItem])
  if (isLoading || isLoadingEdit) return <Loader />
  return (
    <DialogWrapper open={open} setOpen={setOpen} title='Add / Edit Notice Response'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box mt={1}>
          <Controller
            control={control}
            name="responseType"
            render={({ field }) => (
              <Select {...field} fullWidth size="medium" label="Response Type">
                <MenuItem value="FR">Full Response</MenuItem>
                <MenuItem value="PR">Partial Response</MenuItem>
              </Select>
            )}
          />
        </Box>

        <Box mt={1}>
          <FormDate
            name="submittedOn"
            required
            control={control}
            label="Submitted On"
          />
        </Box>

        <Box mt={1}>
          <TextField
            label="Remarks"
            fullWidth
            size='medium'
            {...register(`remarks` as const)}
          />
        </Box>
        <Box mt={1}>
          <LoadingButton
            loading={isLoading}
            disabled={isLoading}
            loadingColor='white'
            type="submit"
            title='Submit'
            color='secondary'
          />
        </Box>
      </form>
    </DialogWrapper>
  )
}

export default CreateNoticeResponse

